<template>
  <el-input :value="formatPhone" @input="onInput" v-bind="$attrs" v-on="$listeners" :maxlength="13"></el-input>
</template>
<script>
export default {
  name: 'InputPhone',
  props: {
    // 手机号码，双向数据绑定
    phone: String,
  },
  model: {
    prop: 'phone',
    event: 'phoneChange',
  },
  computed: {
    // 格式化显示手机号码
    formatPhone: {
      get() {
        const phone = (this.phone || '').replace(/\D/g, '');
        if (phone.length > 6) return phone.replace(/(\d{3})(\d{3})(\d+)/, '$1 $2 $3');
        if (phone.length > 3) return phone.replace(/(\d{3})(\d+)/, '$1 $2');
        return phone;
      },
      set(phone) {
        this.$emit('phoneChange', phone.replace(/\D/g, ''));
      },
    },
  },
  methods: {
    /**
     * 输入时
     */
    onInput(value) {
      this.formatPhone = value.replace(/\D/g, '');
    },
  },
};
</script>
